import { render, staticRenderFns } from "./JcqklrForm.vue?vue&type=template&id=3296e387&scoped=true"
import script from "./JcqklrForm.vue?vue&type=script&lang=js"
export * from "./JcqklrForm.vue?vue&type=script&lang=js"
import style0 from "./JcqklrForm.vue?vue&type=style&index=0&id=3296e387&prod&lang=scss&scoped=true"
import style1 from "./JcqklrForm.vue?vue&type=style&index=1&id=3296e387&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3296e387",
  null
  
)

export default component.exports